<rt-box layout-vertical>
  <div layout-vertical margin-bottom>
    <rt-heading variant="heading large">
      {{ 'app.requisitions.details_page.general.heading' | translate }}
    </rt-heading>
    <rt-heading variant="subheading normal">
      {{ 'app.requisitions.details_page.general.subheading' | translate }}
    </rt-heading>
  </div>
  <div [formGroup]="form" class="details-wrap-grid">
    @if (availableDetailsFields['department']) {
      <rt-form-field [hasLabelMargin]="false">
        <rt-label margin-bottom-small-xx>
          {{ formFieldsConfig.department.label }}
          @if (isDepartmentsMode) {
            <rt-icon-help
              [rtTooltip]="'app.requisitions.details_page.general.department_tooltip' | translate"
              margin-left-small-xx
            ></rt-icon-help>
          }
        </rt-label>
        <rt-requisitions-dynamic-select-field
          [form]="form.controls['departmentId']!"
          [type]="'department'"
          [searchPlaceholder]="formFieldsConfig.department.searchPlaceholder"
          [isReadOnly]="!isFormEditable"
          [isInvalid]="form.controls['departmentId']!.invalid"
        ></rt-requisitions-dynamic-select-field>
      </rt-form-field>
    }
    @if (availableDetailsFields['priority']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.controls.priority?.value && isFormEditable"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.priority' | translate }}
        </rt-label>
        <rt-select
          [options]="selectOptions.priorities"
          [placeholder]="'app.common.select' | translate"
          [hasClearButton]="true"
          [hasInputTrigger]="true"
          [optionTemplate]="optionTemplate"
          [hasSearch]="false"
          [readOnly]="!isFormEditable"
          formControlName="priority"
          [isInvalid]="!!form.controls.priority?.invalid"
        >
        </rt-select>

        <ng-template #optionTemplate let-option="option">
          <div layout-horizontal layout-align-items-center>
            <rt-icon
              [name]="option.icon"
              [colorToken]="option.iconColorToken || 'colorIconDefault'"
              class="option-icon priority-icon"
            ></rt-icon>
            {{ option.label }}
          </div>
        </ng-template>
      </rt-form-field>
    }
    @if (availableDetailsFields['recruiter']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('recruiterId')?.value && isFormEditable"
        class="user-select-field"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.recruiter' | translate }}
        </rt-label>
        <rt-user-select-container
          [control]="form.controls.recruiterId!"
          [isReadOnly]="!isFormEditable"
          [isInvalid]="!form.get('recruiterId')?.valid"
          (valueChange)="setUserSelectFieldValue('recruiterId', $event ? +$event : null)"
        ></rt-user-select-container>
      </rt-form-field>
    }

    @if (availableDetailsFields['hiring_manager']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('hiringManagerId')?.value && isFormEditable"
        class="user-select-field"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.hiring_manager' | translate }}
        </rt-label>
        <rt-user-select-container
          [control]="form.controls.hiringManagerId!"
          [isReadOnly]="!isFormEditable"
          [isInvalid]="!form.get('hiringManagerId')?.valid"
          (valueChange)="setUserSelectFieldValue('hiringManagerId', $event ? +$event : null)"
        ></rt-user-select-container>
      </rt-form-field>
    }

    @if (availableDetailsFields['employment_type']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('employmentType')?.value && isFormEditable"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.employment_type' | translate }}
        </rt-label>
        <rt-select
          [options]="selectOptions.employmentTypes"
          [includeEmptyOption]="false"
          [hasInputTrigger]="true"
          [isInvalid]="!form.get('employmentType')?.valid"
          [readOnly]="!isFormEditable"
          formControlName="employmentType"
        >
        </rt-select>
      </rt-form-field>
    }

    @if (availableDetailsFields['category']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('category')?.value && isFormEditable"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.category' | translate }}
        </rt-label>
        <rt-select
          [options]="selectOptions.categories"
          [includeEmptyOption]="false"
          [hasInputTrigger]="true"
          [isInvalid]="!form.get('category')?.valid"
          [readOnly]="!isFormEditable"
          formControlName="category"
        >
        </rt-select>
      </rt-form-field>
    }
    @if (availableDetailsFields['education']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('education')?.value && isFormEditable"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.education' | translate }}
        </rt-label>
        <rt-select
          [options]="selectOptions.educations"
          [includeEmptyOption]="false"
          [hasInputTrigger]="true"
          [isInvalid]="!form.get('education')?.valid"
          [readOnly]="!isFormEditable"
          formControlName="education"
        >
        </rt-select>
      </rt-form-field>
    }
    @if (availableDetailsFields['experience']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="!form.get('experience')?.value && isFormEditable"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.experience' | translate }}
        </rt-label>
        <rt-select
          [options]="selectOptions.experiences"
          [includeEmptyOption]="false"
          [hasInputTrigger]="true"
          [isInvalid]="!form.get('experience')?.valid"
          [readOnly]="!isFormEditable"
          formControlName="experience"
        >
        </rt-select>
      </rt-form-field>
    }
    @if (availableDetailsFields['hours']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="
          (!form.get('minHoursPerWeek')?.value || !form.get('maxHoursPerWeek')?.value) &&
          isFormEditable
        "
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.offer_form.hours_per_week' | translate }}
        </rt-label>
        <div class="hours-per-week">
          <div layout layout-align-items-center>
            <rt-numeric-input
              [placeholder]="'app.common.min' | translate"
              [readOnly]="!isFormEditable"
              formControlName="minHoursPerWeek"
            >
            </rt-numeric-input>
            <span padding-lr-small-x>{{ 'app.offer_form.to' | translate }} </span>
          </div>
          <div layout layout-align-items-center>
            <rt-numeric-input
              [placeholder]="'app.common.max' | translate"
              [readOnly]="!isFormEditable"
              formControlName="maxHoursPerWeek"
            >
            </rt-numeric-input>
            <span padding-lr-small-x>{{ 'app.offer_form.hours' | translate }}</span>
          </div>
        </div>
      </rt-form-field>
    }
    @if (availableDetailsFields['hiring_budget']) {
      <rt-form-field
        [hasLabelMargin]="false"
        [required]="
          (!form.get('hiringBudget')?.value || !form.get('hiringBudgetCurrency')?.value) &&
          isFormEditable
        "
        class="span-two"
      >
        <rt-label margin-bottom-small-xx>
          {{ 'app.requisitions.form_fields.hiring_budget' | translate }}
          <rt-badge
            color="secondary"
            [text]="'app.requisitions_settings.form_field_badge.requisition_only' | translate"
            margin-left-small-x
          ></rt-badge>
        </rt-label>
        <div class="hiring-budget">
          <rt-numeric-input
            [placeholder]="'app.requisitions.form_fields.hiring_budget_placeholder' | translate"
            [readOnly]="!isFormEditable"
            [updateFormattedValueDispatcher$]="requisitionUpdated$"
            formControlName="hiringBudget"
          ></rt-numeric-input>
          <rt-currency-select-field
            [form]="form.controls['hiringBudgetCurrency']!"
            [placeholder]="'app.offer_form.currency_placeholder' | translate"
            [isReadOnly]="!isFormEditable"
            [isInvalid]="form.controls['hiringBudgetCurrency']!.invalid"
          ></rt-currency-select-field>
        </div>
      </rt-form-field>
    }
    @if (availableDetailsFields['salary']) {
      <rt-salary-form-group
        class="span-three"
        [salaryFormGroup]="form.controls.salary!"
        [isReadOnly]="!isFormEditable"
        [hasRequiredAsterisk]="
          !hasFormGroupAllFieldsFilled(form.controls['salary']) && isFormEditable
        "
        [updateFormattedValueDispatcher]="requisitionUpdated$"
      ></rt-salary-form-group>
    }
    @if (customFieldsFormArray) {
      @for (customFieldGroup of customFieldsFormArray.controls; track $index) {
        <rt-custom-field
          [customFieldFormGroup]="customFieldGroup"
          [isReadOnly]="!isFormEditable"
          [hideRequiredBadges]="!isFormEditable"
          [errorMessagesVisible]="false"
        ></rt-custom-field>
      }
    }
  </div>
</rt-box>
